import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getContentOptions } from '../utils/functions/options';

export function useTransitionImage() {
  const imageFrameLayer =
    '##URL##/extra/image/rxc/frames/##MODEL##__##COLOR##__RXP__FRAME__qt.png';
  const imageLens =
    '##URL##/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png';
  const logoMap = {
    'Costa Del Mar': 'LOGO01',
    'Ray-Ban_C': 'LOGO02',
    'Ray-Ban_P': 'LOGO03',
    'Ray-Ban': 'LOGO04',
    Oakley: 'LOGO05',
    Arnette: 'LOGO08',
    Arnette_P: 'LOGO09',
  };

  const imageLogoLayer =
    '&Logo=##URL##/extra/image/rxc/logo/##MODEL##__RXP__##LOGO##__qt.png';
  const flowDefiningAttributes = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes
  );

  const baseUrlCdn =
    flowDefiningAttributes?.assetsCDN ||
    window.rxcBrain.config.baseURLs?.assetsCDN;

  const selectedTransitionColor = useSelector(
    (state: any) => state.color?.transitionSelected
  );
  const currentPackages = useSelector(
    (state: any) => state.workflow?.currentStepPackages?.validRXPackages
  );

  const imageUrl = window.rxcBrain.config?.data?.frame?.imageUrl;
  const modelFrame = window.rxcBrain.config?.data?.frame?.model;

  const brandFrame = window.rxcBrain.config?.data?.frame?.brand;

  const [cancelToken, setCancelToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [urlImage, setUrlImage] = useState({
    frame: imageUrl,
    lens: null,
    logo: null,
    error: null,
  });

  const getBrandByType = (lensBrand?: string) => {
    return logoMap[lensBrand ? lensBrand : brandFrame];
  };

  useEffect(() => {
    const colorFrame =
      window.rxcBrain.selectedFrameColor?.clen ||
      window.rxcBrain.config?.data?.frame?.color;
    const configColor = getContentOptions(window.rxcBrain?.content, 'color');
    if (
      colorFrame &&
      selectedTransitionColor &&
      currentPackages &&
      configColor.length > 0
    ) {
      let url = imageFrameLayer
        .replace('##MODEL##', modelFrame)
        .replace('##COLOR##', colorFrame)
        .replace('##URL##', baseUrlCdn);

      if (cancelToken) {
        cancelToken.cancel();
        setUrlImage({
          frame: imageUrl,
          lens: null,
          logo: null,
          error: null,
        });
      }

      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      setCancelToken(source);

      let lensBrand = currentPackages.length
        ? currentPackages[0].lensPackage.brand
        : null;
      const findedPackagesColor = currentPackages.map(
        (currentPackage: any) => currentPackage.lensPackage.color
      );
      const packagesColors = configColor.filter((color: any) =>
        findedPackagesColor.find((cl: any) => cl === color.id)
      );
      const color = packagesColors.find((color) =>
        [color.id].includes(selectedTransitionColor)
      );

      const colorPackage = currentPackages
        .filter(
          ({ lensPackage }) =>
            lensPackage.color === color?.id ||
            lensPackage.productUPC === color?.id
        )
        ?.find(({ lensPackage }) => lensPackage.clen);

      if (!colorPackage || (colorPackage && !colorPackage?.lensPackage?.clen)) {
        console.log(`Clen not found for color "${color?.id}"`);
        setUrlImage({
          frame: null,
          lens: null,
          logo: null,
          error: true,
        });
        return;
      }

      if (brandFrame && brandFrame == lensBrand) {
        const imageLogoMapped = getBrandByType();

        let urlLensesImage = imageLens
          .replace('##MODEL##', modelFrame)
          .replace('##CLEN##', colorPackage.lensPackage.clen)
          .replace('##URL##', baseUrlCdn);

        const lensLogoMapped = getBrandByType(lensBrand);

        setIsLoading(true);

        axios
          .get(urlLensesImage, {
            cancelToken: source.token,
          })
          .then(() => {
            axios
              .get(url, {
                cancelToken: source.token,
              })
              .then(() => {
                let compositionLogo = imageLogoLayer
                  .replace('##MODEL##', modelFrame)
                  .replace('##LOGO##', lensLogoMapped)
                  .replace('##URL##', baseUrlCdn)
                  .replace('&Logo=', '');
                return axios
                  .get(compositionLogo, {
                    cancelToken: source.token,
                  })
                  .then(() => {
                    setUrlImage({
                      frame: url,
                      lens: urlLensesImage,
                      logo: compositionLogo,
                      error: null,
                    });
                    setIsLoading(false);
                  })
                  .catch(() => {
                    setUrlImage({
                      frame: url,
                      lens: urlLensesImage,
                      logo: null,
                      error: true,
                    });
                    setIsLoading(false);
                  });
              })
              .catch(() => {
                setUrlImage({
                  frame: null,
                  lens: null,
                  logo: null,
                  error: true,
                });
                setIsLoading(false);
              });
          })
          .catch(() => {
            setUrlImage({
              frame: null,
              lens: null,
              logo: null,
              error: true,
            });
            setIsLoading(false);
          });
      } else {
        let urlLensesImage = imageLens
          .replace('##MODEL##', modelFrame)
          .replace('##CLEN##', colorPackage.lensPackage.clen)
          .replace('##URL##', baseUrlCdn);

        setIsLoading(true);

        axios
          .get(urlLensesImage, {
            cancelToken: source.token,
          })
          .then(() => {
            axios
              .get(url, {
                cancelToken: source.token,
              })
              .then(() => {
                setUrlImage({
                  frame: url,
                  lens: urlLensesImage,
                  logo: null,
                  error: null,
                });
                setIsLoading(false);
              })
              .catch((error) => {
                if (!axios.isCancel(error)) {
                  setUrlImage({
                    frame: null,
                    lens: null,
                    logo: null,
                    error: true,
                  });
                }
                setIsLoading(false);
              });
          })
          .catch((error) => {
            if (!axios.isCancel(error)) {
              setUrlImage({
                frame: null,
                lens: null,
                logo: null,
                error: true,
              });
              setIsLoading(false);
            }
          });
      }
    } else {
      if (currentPackages && selectedTransitionColor && !colorFrame) {
        //general fallback to show the swatch with slider
        setUrlImage({
          frame: null,
          lens: null,
          logo: null,
          error: true,
        });
      }
    }
  }, [selectedTransitionColor]);

  return { urlImage, isLoading };
}
